import type { ReactNode } from 'react'
import classnames from 'classnames'
import { Typography } from 'shared/ui'
import styles from './styles.module.scss'

type IWidgetCardProps = {
  children: ReactNode
  className?: string
  header?: string
}

export const WidgetCard = ({ children, className, header }: IWidgetCardProps) => {
  return (
    <div className={classnames(styles.card, className)}>
      {header && (
        <div className={styles.header}>
          <Typography variant='body-lg-medium' ariaLabel={header}>
            {header}
          </Typography>
        </div>
      )}
      {children}
    </div>
  )
}
